import { useState } from 'react';
import { faChevronDown, faChevronRight, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@nazka/nazka.mapframe.components';

import { useTranslation } from '@utils/i18n/i18n';

import { SPECIES_GROUPS } from '../../map.constants';

import './species-list.css';

function SpeciesList({ feature, onClose }) {
  const { t } = useTranslation();
  const [openGroup, setOpenGroup] = useState(null);
  const taxaObservations = feature?.properties?.taxaObservations ?? {};

  return (
    <div className="species-list">
      <div className="species-list__header">
        <span className="species-list__title">{feature?.properties?.name}</span>
        {onClose && (
          <button className="species-list__close" onClick={onClose}>&times;</button>
        )}
      </div>
      {Object.entries(SPECIES_GROUPS).map(([key, config]) => {
        const group = taxaObservations[key];
        const isOpen = openGroup === key;

        return (
          <div key={key} className="species-list__group">
            <button
              className="species-list__group-header"
              style={{ backgroundColor: config.color }}
              onClick={() => setOpenGroup(isOpen ? null : key)}
            >
              <Icon icon={config.icon} size="16px" />
              <span>{`${t(config.label)} ${t('species')} (${group?.taxons?.length ?? 0})`}</span>
              <Icon
                className="species-list__group-caret"
                icon={isOpen ? faChevronUp : faChevronDown}
                size="16px"
              />
            </button>
            {isOpen && group?.taxons && (
              <div className="species-list__items">
                {group.taxons.map(taxon => (
                  <a
                    key={taxon.taxon_id}
                    className="species-list__item"
                    href={taxon.taxon_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="species-list__item-img"
                      src={taxon.photo_url}
                      alt=""
                      loading="lazy"
                    />
                    <div className="species-list__item-info">
                      <span className="species-list__item-name">
                        {taxon.common_name || taxon.specie_name}
                      </span>
                      {taxon.common_name && (
                        <span className="species-list__item-specie">
                          {taxon.specie_name}
                        </span>
                      )}
                    </div>
                    <Icon
                      className="species-list__item-arrow"
                      icon={faChevronRight}
                      size="16px"
                    />
                  </a>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default SpeciesList;
